import { graphql } from 'react-relay';

export const marketingTermAgreement = graphql`
  query marketingTermQuery {
    getRefundUserMarketingTerm {
      terms {
        termKey
        isApproved
      }
      result
      errors {
        code
        message
      }
    }
  }
`;

export const updateMarketingTerm = graphql`
  mutation marketingTermUpdateMutation($termKey: String!, $isApproved: Boolean!) {
    updateRefundUserMarketingTerms(terms: { termKey: $termKey, isApproved: $isApproved }) {
      terms {
        termKey
        isApproved
      }
      result
      errors {
        code
        message
      }
    }
  }
`;
